import React, { useState } from "react";
import Sidebar from "../utils/unifiedSidebar";
import Header from "../components/Feed-Page/Header";
import FeedCategories from "../components/Feed-Page/FeedCategories";
import BottomNavbar from "../utils/unifiedBottom";

const FeedPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Main Content */}
      <div className="min-[1285px]:ml-64 min-h-screen pb-20 sm:pb-0">

        {/* Header */}
        <Header setSidebarOpen={setSidebarOpen} />
        
        {/* Feed Categories */}
        <FeedCategories />
        
        {/* Bottom Navbar */}
        <BottomNavbar sidebarOpen={sidebarOpen} />
      </div>
    </div>
  );
};
export default FeedPage;